import { format, formatISO } from 'date-fns'

import { CmsUser } from '../api/types'

export const formattedUsername = ({
  username,
}: Pick<CmsUser, 'username'>): string => `@${username}`

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

export const formattedUsd = (price: number) => USD_FORMATTER.format(price / 100)

const STAT_FORMATTER = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const STAT_THOUSANDS_FORMATTER = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

export const formattedStat = (views: number): string =>
  views >= 1000
    ? `${STAT_THOUSANDS_FORMATTER.format(views / 1000)}K`
    : STAT_FORMATTER.format(views)

export const formatDate = (date: Date) => format(date, 'MM.dd.yyyy')

export const getDateMonth = (date: Date) => format(date, 'MM')
export const getDateDate = (date: Date) => format(date, 'dd')
export const getDateYear = (date: Date) => format(date, 'yy')

export const formatDateIso = (date: Date) =>
  formatISO(date, { representation: 'date' })

export const formatDecimalUsd = (price: number) =>
  `${price.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })}`

export const formatPriceUsd = (price: number) => `$${formatDecimalUsd(price)}`
